import { Col, If, Option, Row, Select, Spacer, Text } from '@app/components'
import { Dispatch } from 'react'

interface CustomType {
  selected?: any
  setSelected?: Dispatch<any>
  list: any[]
  type: string
  onChange?: any
}

export const CustomSelect: React.FC<CustomType> = ({ list, setSelected, type, selected, onChange }) => {
  const handleOnSelect = (id) => {
    const item = list?.find((obj) => obj.id === id)
    const duplicateItem = { ...item }
    delete duplicateItem?.icon
    setSelected(duplicateItem)
    if (onChange) {
      onChange(id)
    }
  }

  const CustomOption = ({ item }) => {
    return (
      <Row gutter={[10, 10]}>
        <If condition={item?.icon}>
          <Col>{item.icon}</Col>
        </If>
        <Col>
          <Text>{item.name}</Text>
          <Spacer value={1} />
          <If condition={item.description}>
            <Text type="secondary">{item.description}</Text>
          </If>
        </Col>
      </Row>
    )
  }

  return (
    <Select
      placeholder={`Select ${type}`}
      fluid
      onSelect={handleOnSelect}
      value={selected?.id}
      getPopupContainer={(trigger) => trigger.parentNode}
    >
      {list?.map((item, index) => (
        <Option key={index} value={item.id}>
          <CustomOption item={item} />
        </Option>
      ))}
    </Select>
  )
}
